import { Attrs, MinzeElement } from 'minze'

export interface LvcShareLinkedinIcon {}

export class LvcShareLinkedinIcon extends MinzeElement {
  attrs: Attrs = [
    ['width', '32'],
    ['height', '32'],
  ]

  html = () => `
    <svg part="icon" width="${this.width}" height="${this.height}" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.72083 28.7445V11.5461H3.00443V28.7445H8.72083ZM5.8626 9.19799C7.85603 9.19799 9.09677 7.87735 9.09677 6.22693C9.05962 4.53936 7.85603 3.25537 5.90042 3.25537C3.94501 3.25537 2.6665 4.53936 2.6665 6.22693C2.6665 7.87735 3.90698 9.19799 5.82534 9.19799H5.86249H5.8626Z" fill="#1E007D"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8838 28.7445H17.6001V19.1402C17.6001 18.6262 17.6373 18.1127 17.7882 17.7452C18.2015 16.7183 19.1421 15.6546 20.7212 15.6546C22.7897 15.6546 23.6172 17.2317 23.6172 19.5438V28.7445H29.3331V18.8832C29.3331 13.6006 26.5129 11.1426 22.752 11.1426C19.6681 11.1426 18.3143 12.8663 17.5621 14.0403H17.6003V11.5461H11.8839C11.959 13.1599 11.8839 28.7445 11.8839 28.7445H11.8838Z" fill="#1E007D"/>
    </svg>
  `

  css = () => `
    
  `
}
